/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "b02060328b269fd4131a26d3cd3288f8df457a2a";
